import { render, staticRenderFns } from "./ConfiguracaoPrivilegioPerfilList.vue?vue&type=template&id=615ce4fb&scoped=true"
import script from "./ConfiguracaoPrivilegioPerfilList.vue?vue&type=script&lang=js"
export * from "./ConfiguracaoPrivilegioPerfilList.vue?vue&type=script&lang=js"
import style0 from "./ConfiguracaoPrivilegioPerfilList.vue?vue&type=style&index=0&id=615ce4fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615ce4fb",
  null
  
)

export default component.exports